import { MB } from '@app/constant/sizes';

export const TransferConfig = Object.freeze({
  // Settings for chunk uploads
  upload: {
    chunk: {
      minSize: 5 * MB,
      maxCount: 999,
    },

    retry: {
      limit: 100,
      interval: 2000,
    },

    remainingTimeInterval: 10000,
  },

  // Settings for the queue
  queue: {
    concurrency: 3,
  },

  // Settings for the progress indicator
  progress: {
    interval: 500,
  },

  // Settings for API requests
  api: {
    endpoint: '/api/v4',
    // Timeout regular requests in 30s
    timeout: 30 * 1000,
    // Timeout retriable requests in 60 minutes.
    // This is the total time for all retries.
    retriableTimeout: 60 * 60 * 1000,
    retry: {
      limit: 100,
    },
  },
});
